module.exports = __webpack_public_path__ + "img/00041.ae6d68a5.webp";